import { createAction, props } from '@ngrx/store';
import { RouteModels } from '@share-models';

export const resetToInitialState = createAction('[ROUTE] Reset to Initial state');

export const setBreadcrumbs = createAction('[ROUTE] Set breadcrumbs', props<{ breadcrumbs: RouteModels.UiBreadCrumbItem[] }>());

